import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import {
  getCoreDomain,
  CORE_API_ENTRYPOINT,
  customHeaders,
  customHeadersLD,
} from '@probatix/common/services/services.helpers'

import {
  ITestResult,
  ITestResultPayload,
} from './testResultService.model'

const query = 'orderBy[patientEvent.testEndTime]=desc&patientEvent.status[]=finished&page='
const partial = '&partial=false'

// Define a service using a base URL and expected endpoints
export const testResultApi = createApi({
  baseQuery: fetchBaseQuery({ baseUrl: getCoreDomain() }),
  endpoints: (builder) => ({
    getComparableResults: builder.query<ITestResult[], ITestResultPayload>({
      query: ({ loincNum }) => ({
        headers: customHeaders(),
        method: 'GET',
        url: `${CORE_API_ENTRYPOINT}/api/v0/test_results?orderBy[testTime]=desc&loincNum=${loincNum}`,
      }),
    }),
    getResults: builder.query<ITestResult[], any>({
      query: ({ getTotalItem, page }) => ({
        headers: customHeadersLD(),
        method: 'GET',
        url: `
        ${CORE_API_ENTRYPOINT}/api/v0/test_results?${query}${page}${getTotalItem ? partial : ''}
        `,
      }),
    }),
  }),
  reducerPath: 'testResultApi',
})

export const useGetResults = testResultApi.endpoints.getResults.useLazyQuery
export const useGetComparableResults = testResultApi.endpoints.getComparableResults.useLazyQuery

